import { useState, useEffect, useRef } from 'react';
import { useParams } from "react-router-dom";
import OrganigramaAreaDataService from './services/organigramaarea.service';
import OrganigramaDataService from "./services/organigrama.service";
import CompetenciaDataService from './services/competencia.service';
import { Container, Row, Tooltip, Table, Col, FormLabel, FormControl, Button, Form, Badge } from 'react-bootstrap';
import Sidebar from "./Sidebar";
import ExportSidebar from "./ProSideBar";
import { dtFormatter, PageHeader } from './AuxiliaryFunctions';
import { useDispatch, useSelector } from "react-redux";
import MessageBox from './MessageBox';
import { jsPDF } from 'jspdf'
import { autoTable } from 'jspdf-autotable'
import { FaEdit, FaFilePdf } from "react-icons/fa";
import { IoSave } from 'react-icons/io5';
import { logout } from './actions/auth';
import './App.css';

const ListaDeJueces = () => {
  let params = useParams();
  let organigramaid = params.organigramaid;
  let competenciaid = params.competenciaid;
  let userid = params.userid; // it might not be the current user

  const dispatch = useDispatch();

  console.log(competenciaid);

  const { user: currentUser } = useSelector((state) => state.auth);	

  const [errmessage, setErrmessage] = useState("");
  const [showerror, setShowerror] = useState(false);
  const [succmessage, setSuccmessage] = useState("");
  const [showsuccess, setShowsuccess] = useState(false);

  const [listOfJudges, setListofJudges] = useState([]);
  const [organigrama, setOrganigrama] = useState({});
  const [competencia, setCompetencia] = useState({});

  const onExportPDF = () => {
    const doc = new jsPDF({orientation: 'landscape'});

    // 📝 Add a title
    doc.setFontSize(14);
    doc.text('Reporte de jueces asignados', 14, 12);

    // 📄 Add a subtitle or description
    doc.setFontSize(12);
    doc.text('Organigrama: ' + organigrama.nombreorganigrama, 14, 20);
    doc.text('Competencia: ' + competencia.nombrecompetencia, 14, 28);

    const headerarray = ["Categoría", "Nombre área", "Nombre Juez", "Teléfono", "Firma", "Comentarios del organizador"];
    const bodyarray = listOfJudges.map(obj => {
      return [
        obj.childcategory, 
        obj.displayName?obj.displayName:obj.nombreareaorposicion, 
        (obj.primerapellido?obj.primerapellido + " ":"") + (obj.segundoapellido?obj.segundoapellido + ", ":"") + (obj.primernombre?obj.primernombre:""), 
        obj.telefonomovil, 
        "",
        ""
      ];
    });

    console.log(bodyarray);

    // 📊 Add the table
    autoTable(doc, {
      head: [headerarray],
      body: bodyarray,
      startY: 35, // 👈 Push table below the text
    })

    // 🧾 Add footer or additional notes
    const finalY = doc.lastAutoTable.finalY;
    doc.setFontSize(10);
    doc.text('Generado fecha y hora local: ' + new Date(), 14, finalY + 10);

    doc.save('Lista de jueces.pdf')
  };  

  const onSaveSalario = (organigramaareasid, salario) => {
    console.log(organigramaareasid,salario);
    OrganigramaAreaDataService.update(organigramaareasid, {salario: salario})
    .then(resp => {
      console.log(resp);
    })
    .catch(err => {
      console.log(err);
    })
  };

  useEffect(() => {   
    OrganigramaDataService.get(organigramaid)
    .then(resp => {
      setOrganigrama(resp.data);
    })
    .catch(e => {
      setShowsuccess(false);
      setSuccmessage("");
      setErrmessage(e.response.data);
      setShowerror(true);
    });
    
    OrganigramaAreaDataService.getList(organigramaid, competenciaid, userid)
      .then(resp => {
        console.log(resp.data);
        setListofJudges(resp.data);
      })
      .catch((e) => {
        if (e.response.status == 401) {
          dispatch(logout())
          .then(() => {
            window.location.reload();
          });
        }
        else {
          console.log(e.response.data);
          setSuccmessage("");
          setShowsuccess(false);
          setErrmessage(e);
          setShowerror(true);
        }
      });  
    
    CompetenciaDataService.get(competenciaid)
      .then(resp => {
        console.log(resp.data);
        setCompetencia(resp.data);
      })
      .catch((e) => {
        if (e.response.status == 401) {
          dispatch(logout())
          .then(() => {
            window.location.reload();
          });
        }
        else {
          console.log(e.response.data);
          setSuccmessage("");
          setShowsuccess(false);
          setErrmessage(e.response.data);
          setShowerror(true);
        }
      });     
     
    
  }, []);  
  
  return (
    <>
    <Sidebar />
    <div style={{display:'flex', flexDirection:'row', gap:'10px'}}>      
      <ExportSidebar roles={currentUser.roles}/>
      <Container>
        <PageHeader />  
        <Row className='mb-2 d-flex'>
          <h5 className='mb-4' style={{width: "100%", textAlign: "center", marginLeft: "0%", color: "green" }}>Lista de jueces</h5>
        </Row>          
        <Row className='mb-2 d-flex'>          
          <Col lg={4}>
            <FormLabel className='mb-2'>Nombre del organigrama:</FormLabel>       
            <FormControl type="text" name="nombreorganigrama" id="nombreorganigrama" disabled defaultValue={organigrama?organigrama.nombreorganigrama:""}></FormControl>
          </Col>
          <Col lg={4}>
            <FormLabel className='mb-2'>Descripción del organigrama:</FormLabel>       
            <FormControl type="text" name="descripcionorganigrama" id="descripcionorganigrama" disabled defaultValue={organigrama?organigrama.descripcionorganigrama:""}></FormControl>                          
          </Col>
        </Row>  

        <Row className='mb-2 d-flex'>          
          <Col lg={4}>
            <FormLabel className='mb-2'>Nombre de la competencia:</FormLabel>       
            <FormControl type="text" name="nombrecompetencia" id="nombrecompetencia" disabled defaultValue={competencia?competencia.nombrecompetencia:""}></FormControl>            
          </Col>
          <Col lg={4}>
            <FormLabel className='mb-2'>Fecha de inicio:</FormLabel>       
            <FormControl 
              type="text" 
              name="fecha inicio" 
              id="fecha inicio" 
              disabled
              defaultValue={competencia?competencia.fechainicio:""}
            >
            </FormControl>                          
          </Col>
        </Row>  

        <Row className='mb-2 d-flex'>   
          <Col lg={4}>
            <FormLabel className='mb-2'>Estatus de la competencia: </FormLabel>       
            {
              competencia.estatus_competencia===1?<Badge bg="secondary">Preliminar</Badge>:
              competencia.estatus_competencia===2?<Badge bg="success">Abierta</Badge>:
              competencia.estatus_competencia===3?<Badge bg="warning">En curso</Badge>:
              competencia.estatus_competencia===4?<Badge bg="danger">Cerrada</Badge>:null
            }          
          </Col>
        </Row>

        <hr />

        <Row className='mb-2 d-flex'>
          <Col lg={4}>
            <FormLabel style={{marginRight:'10px'}}>{"Exportar lista:"}</FormLabel>
            <Button onClick={onExportPDF}><FaFilePdf size={15} color='white'/></Button>
          </Col>          
        </Row>                
        <Row>
          <ListaJuecesOrganigrama listOfJueces={listOfJudges} onSaveSalario={onSaveSalario}/>
        </Row>

          
      </Container>
      
    </div>




    <Row className='mt-2'>

      {showerror && (
        <MessageBox show={true} showerror={showerror} errmessage={errmessage}
          onHide={() => {
            setShowerror(false)
          }}
        />
      )}
      {showsuccess && (
        <MessageBox show={true} showsuccess={showsuccess} succmessage={succmessage}
          onHide={() => {
          setShowsuccess(false);
          window.location.reload();
        }}
        />
      )}

    </Row>   
    </>   
  );    
};

const TableHeader = (props) => {
  return (

    <thead>
      <tr>
        <th style={{width:'8%'}}>Categoría</th>
        <th style={{width:'15%'}}>Nombre área o posición</th>
        <th style={{width:'15%'}}>Juez asignado</th>
        <th style={{width:'10%'}}>Teléfono del juez</th>
        <th style={{width:'10%'}}>Salario</th>
        <th style={{width:'10%'}}>Calificación</th>
        <th style={{width:'30%'}}>Comentarios del administrador</th>
      </tr>
    </thead>
  )
}

const TableBody = (props) => {  
  
  if (props.listOfJueces) {
    
    const rows = props.listOfJueces.map((row, index) => { 

      const [editMode, setEditMode] = useState(false);
      const [updatedSalario, setUpdatedSalario] = useState(row.salario);
      const inputSalarioRef = useRef();

      const onChangeEditMode = () => {
        //if (editMode) {
          inputSalarioRef.current.select();
        //}
        setEditMode(!editMode);
      };

      const onUpdateSalario = (e) => {        
        setUpdatedSalario(e.target.value);
      }

      const onSaveUpdatedSalario = () => {
        props.onSaveSalario(row.organigramaareasId, updatedSalario);        
        setEditMode(false);
      }

      return (
        <>
        <tr key={index}>        
          <td>
            {row.childcategory}
          </td>
          <td style={{whiteSpace:'pre'}}>  
            {row.displayName?row.displayName:row.nombreareaorposicion}
          </td>
          <td>  
            {row.userId?(row.primerapellido + ", " + row.primernombre):<span style={{color:"red"}}>No se ha asignado el juez!</span>}
          </td>   
          <td>
            <a href={"sms:+" + row.telefonomovil}>
              {row.telefonomovil}
            </a>                                  
          </td>
          <td>
            <div style={{display:'flex',flexDirection:'row',gap:'5px',alignItems:'center'}}>
              $
              <FormControl 
                disabled={!editMode}
                style={{maxWidth:"300px",textAlign:'right'}} 
                type="number" 
                name="salario" 
                id="salario"
                defaultValue={row.salario}
                onChange={onUpdateSalario}
                ref={inputSalarioRef}
              />              
              {(editMode) && 
                <Button className='bg-success' onClick={onSaveUpdatedSalario}><IoSave color='white'/></Button>
              }
              {(!editMode) &&
                <Button className='btn-secondary' onClick={onChangeEditMode}><FaEdit color='white'/></Button>
              }
            </div>             
          </td>    
          <td>
            
          </td>      
          <td>

          </td>
        </tr>
        </>      
      )
    })
    return (
      <tbody>
        {rows}
      </tbody>
    )  
  }
  else {
    return null;
  }
}

const renderEditTooltip = (props) => (
  <Tooltip id="button-tooltip" {...props}>
    Click to edit the user.
  </Tooltip>
);

const ListaJuecesOrganigrama = (props) => {        
  return (
      <>
      <Container>
        <Row>
          <Table style={{verticalAlign:"baseline"}} bordered hover size="sm">
            <TableHeader/>
            <TableBody listOfJueces={props.listOfJueces} onSaveSalario={props.onSaveSalario}/>
          </Table>
        </Row>
        <hr/>
      </Container>
      </>
    );
};

export default ListaDeJueces;